
import {THREE} from '../../utils/three.js'
import TILES_DATAS from './tilesLanding.js'


const VERTEX_SHADER = require( './../../utils/three/shader/basicVertexShader.glsl' )
const FRAGMENT_SHADER = require( './../../utils/three/shader/progressLoadFragmentShader.glsl' )


const TEX_LOADER = new THREE.TextureLoader()


function rand( min, max )
{
    return Math.random() * (max - min) + min
}

/*function mix( a, b, val )
{
    return a * val + b * (1 - val)
}*/

/*function easeInExpo( v )
{
    return Math.pow( 2, 10 * (v - 1) )
}

function easeOutExpo ( v )
{
    return -Math.pow( 2, -10 * v ) + 1
}*/

function easeInCirc ( v )
{
    return -(Math.sqrt(1 - v * v) - 1)
}

function lerp( a, b, v )
{
    return v * (b - a) + a
}


export default class BgLanding {

    constructor( canvas, w, h, touch, isLoadedCallback )
    {
        this._loadCounter = 0
        this._tileDataList = []
        this._timeLimit

        this._mouseX = 0.5
        this._mouseY = 0.5
        this._w = w
        this._h = h
        this._touch = touch

        this._onMouseMove = this._onMouseMove.bind(this)
        this._onOrientation = this._onOrientation.bind(this)

        this._isLoadedCallback = isLoadedCallback
        this._initThree( canvas, w, h )
    }

    resize( w, h )
    {
        this._w = w
        this._h = h
        this._camera.aspect = w / h
        this._camera.updateProjectionMatrix()
        this._renderer.setSize(w, h)
    }

    update( dt )
    {
        if (this._renderer)
        {
            if (this._started && !this._leaved)
            {
                // MESH
                const timeMs = Date.now() - this._startTime
                const time = 1 - timeMs / 40000

                for(const {pos1, pos2, rot1, rot2, mesh} of this._tileDataList)
                {
                    mesh.position.z = lerp(pos2.z, pos1.z, time)

                    const meshRot = mesh.rotation
                    meshRot.x = lerp(rot2.x, rot1.x, time)
                    meshRot.y = lerp(rot2.y, rot1.y, time)
                    meshRot.z = lerp(rot2.z, rot1.z, time)
                }


                // CAMERA
                const pos = this._camera.position
                const rot = this._camera.rotation

                const mX = this._mouseX
                const mY = this._mouseY

                const rotP = 0.5    // Rotation max in radian
                const posP = 10     // Position max in pixels
                const slow = 0.01   // Velocity of camera movments

                rot.x = ((0.5 - mY) * rotP - rot.x) * slow + rot.x
                rot.y = ((0.5 - mX) * rotP - rot.y) * slow + rot.y

                pos.x = ((mX - 0.5) * posP - pos.x) * slow + pos.x
                pos.y = ((0.5 - mY) * posP - pos.y) * slow + pos.y


                // END
                if (timeMs >= this._timeLimit)
                {
                    this._onFinished()
                    this.leave()
                }
            }


            // LEAVE
            if (this._leaved)
            {
                // Begin leave
                if (!this._leaveStartData)
                {
                    const pos = this._camera.position
                    const rot = this._camera.rotation

                    this._leaveStartData = {
                        posY: pos.y,
                        rotX: rot.x,
                        tStart: Date.now() - 16
                    }

                    this._started = false
                }

                const data = this._leaveStartData
                const t = Math.max((Date.now() - data.tStart) / 3000, 0)
                const v = easeInCirc( t )

                this._camera.position.y = lerp( data.posY , -1500, v )
                this._camera.rotation.x = lerp( data.rotX , Math.PI * 0.4, v )
                // data.pos.x
            }

            this._composer.render(0.01)
        }
    }

    leave()
    {
        this._leaved = true
    }

    start( timeLimit, onFinishCallback )
    {
        this._timeLimit = timeLimit

        if (this._touch && window.DeviceOrientationEvent)
        {
            window.addEventListener('deviceorientation', this._onOrientation, false)
        }

        window.addEventListener('mousemove', this._onMouseMove, false)


        this._started = true
        this._startTime = Date.now()
        this._onFinished = onFinishCallback
    }

    dispose()
    {
        if (this._touch && window.DeviceOrientationEvent)
        {
            window.removeEventListener('deviceorientation', this._onOrientation)
        }

        window.removeEventListener('mousemove', this._onMouseMove)


        this._isLoadedCallback = () => {}

        if (this._scene)
        {
            while(this._scene.children.length > 0)
            {
                const child = this._scene.children[0]

                const mat = child.material
                if (mat)
                {
                    if (mat.map)
                    {
                        mat.map.dispose()
                    }

                    mat.dispose()
                }

                // child.dispose()
                this._scene.remove(child)
            }

            this._scene = null
        }
    }



    /*
            ┌─────────────────────────────────────────────
            │
            │       INIT
            │
            └─────────────────────────────────────────────
    */

    _initThree( canvas, width, height )
    {
        const camera = this._initCam(width, height)
        const renderer = new THREE.WebGLRenderer({
            // precision — Shader precision. Can be "highp", "mediump" or "lowp". Defaults to "highp" if supported by the device.
            canvas,
            premultipliedAlpha : false,
            // antialias : true,
            stencil : false,
            depth : false,
            // logarithmicDepthBuffer : false
        })
        const scene = this._initScene()

        renderer.setSize(width, height)
        renderer.autoClear = false
        // renderer.gammaInput = true
        // renderer.gammaOutput = true
        renderer.precision = 'lowp'
        renderer.premultipliedAlpha = false
        renderer.stencil = false
        renderer.preserveDrawingBuffer = false
        renderer.depth = false
        renderer.setClearColor(0x1b1820)
        scene.add(camera)
        // webglContainerDOM.appendChild(renderer.domElement)

        this._addTiles(scene)
        renderer.render(scene, camera)

        this._camera = camera
        this._renderer = renderer
        this._scene = scene

        const composer = this._initComposer(renderer, scene, camera)
        renderer.clear
        this._composer = composer
    }

    _initScene()
    {
        const scene = new THREE.Scene()
        scene.frustumCulled = false
        scene.matrixAutoUpdate = false

        return scene
    }

    _initComposer( renderer, scene, camera )
    {
        const composer = new THREE.EffectComposer( renderer )
        const renderPass = new THREE.RenderPass( scene, camera )
        composer.addPass( renderPass )

        const effectFilm = new THREE.FilmPass( 0.35, 0.025, 648 )
        effectFilm.renderToScreen = true
        composer.addPass( effectFilm )

        return composer
    }

    _initCam( width, height )
    {
        const viewAngle = 45
        const aspect = width / height
        const near = 0.1
        const far = 1000

        const cam = new THREE.PerspectiveCamera(
            viewAngle,
            aspect,
            near,
            far
        )

        cam.position.z = 300

        return cam
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       THREE OBJECTS
            │
            └─────────────────────────────────────────────
    */

    _addTiles( container )
    {
        for(const tileData of TILES_DATAS)
        {
            this._addTile(container, tileData)
        }
    }

    _addTile( container, { x, y, z, w, h, src } )
    {
        const geom = this._getPlaneGeom()
        const mat = this._getMat(src)
        const mesh = new THREE.Mesh(geom, mat)

        mesh.position.set(x, y, z)
        mesh.scale.set(w, h, 1)

        container.add(mesh)

        const tileData = {

            mesh,

            pos1: {
                x,
                z,
                y
            },
            pos2: {
                x,
                y,
                z: z + 450
            },

            rot1: {
                x: rand(-0.2, 0.2),
                y: rand(-0.2, 0.2),
                z: 0// rand(-0.05, 0.05)
            },

            rot2: {
                x: rand(-0.2, 0.2),
                y: rand(-0.2, 0.2),
                z: 0 // rand(-0.05, 0.05)
            }
        }

        this._tileDataList.push(tileData)
    }

    _getMat( src )
    {
        const mat = new THREE.MeshBasicMaterial({
            transparent: false,
            lights: false,
            fog: false
        })

        this._addLoadItem()
        TEX_LOADER.load( src, (tex) => {

            tex.format = THREE.RGBFormat

            mat.map = tex
            mat.needsUpdate = true

            this._rmLoadItem()
        })

        return mat
    }

    _getPlaneGeom()
    {
        if (this._planeGeom == undefined)
        {
            this._planeGeom = new THREE.PlaneBufferGeometry(1, 1, 1, 1)
        }

        return this._planeGeom
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       EVENTS
            │
            └─────────────────────────────────────────────
    */

    _onMouseMove( { clientX, clientY } )
    {
        this._mouseX = clientX / this._w
        this._mouseY = clientY / this._h
    }

    _onOrientation( { alpha, beta, gamma } )
    {
        this._mouseX = 1 - (gamma + 90) / 180
        this._mouseY = 1 - (beta + 180) / 360
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       BG LOADER
            │
            └─────────────────────────────────────────────
    */

    _addLoadItem()
    {
        this._loadCounter++
    }

    _rmLoadItem()
    {
        if (--this._loadCounter <= 0)
        {
            this._isLoadedCallback()
        }
    }
}
